import * as React from 'react';

import { useMainContainerRef } from '../../../contexts/MainContainerRefContext';

export interface IMainContentOverlayProps {
    children: React.ReactNode;
}

export function AnnouncementOverlay(props: IMainContentOverlayProps) {
    const mainRef = useMainContainerRef();
    const [offset, setOffset] = React.useState({ top: 0, left: 0 });

    const updateOffset = () => {
        if (mainRef?.current) {
            const rect = mainRef.current.getBoundingClientRect();
            setOffset({ top: rect.top + window.scrollY, left: rect.left + window.scrollX });
        }
    };

    React.useEffect(() => {
        updateOffset();
        window.addEventListener('resize', updateOffset);
        return () => window.removeEventListener('resize', updateOffset);
    }, [mainRef]);

    const overlayStyle = {
        backgroundColor: '#000000',
        opacity: 0.5,
        bottom: 0,
        left: 0,
        overflow: 'auto',
        position: 'fixed',
        right: 0,
        top: offset.top,
        zIndex: 10,
    } as React.CSSProperties;

    return <div style={overlayStyle}>{props.children}</div>;
}
